import * as React from "react";
import { createTheme, useTheme, ThemeProvider, Box } from "@mui/material";

const ThemeContext = ({ children }) => {
  // const [currentTheme, setCurrentTheme] = React.useState("light");

  const lightTheme = createTheme({
    palette: {
      primary: {
        main: "#05103A",
      },
      secondary: {
        main: "#182548",
      },
      whiteColor: {
        main: "#FFFFFF",
      },
      whatsapp: {
        main: "#39AE26",
      },
    },
    typography: {
      fontFamily: [
        "'Poppins', sans-serif",
        "'Roboto Mono', monospace",
        "Courier New",
        "Courrier",
        "Nimbus Mono L",
      ].join(","),
      fontWeightBlack: 900,
      fontWeightThin: 200,
    },
  });

  const darkTheme = createTheme({
    typography: {
      ...lightTheme.typography,
    },
    palette: {
      ...lightTheme.palette,
      primary: {
        main: "#FFFFFF",
      },
    },
    typography: {
      fontFamily: ["Chilanka", "cursive"].join(","),
      fontWeightBlack: 900,
      fontWeightThin: 200,
    },
  });

  const themes = {
    light: lightTheme,
    dark: darkTheme,
  };

  // React.useEffect(() => {
  //   const current_theme = window.localStorage.getItem("theme");
  //   // console.log(current_theme);
  //   if (typeof current_theme === "string") {
  //     setCurrentTheme(current_theme);
  //   } else {
  //     window.localStorage.setItem("theme", currentTheme);
  //   }
  // }, []);

  // const themeToggle = () => {
  //   if (window.localStorage.getItem("theme") === "light") {
  //     setCurrentTheme("dark");
  //     window.localStorage.setItem("theme", "dark");
  //   } else {
  //     setCurrentTheme("light");
  //     window.localStorage.setItem("theme", "light");
  //   }
  // };

  const ThemeContextt = React.createContext({});

  return (
    <ThemeProvider theme={themes["light"]}>
      <ThemeContextt.Provider value={{ toggleTheme: () => 1 }}>
        {children}
      </ThemeContextt.Provider>
    </ThemeProvider>
  );
};

export default ThemeContext;
